import { motion } from 'framer-motion'
import Reveal from './Reveal'

const cursos = [
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" opacity="0.35">
        <path d="M26 10c0 0-14 8-14 18a14 14 0 0028 0C40 18 26 10 26 10z" stroke="#C9A84C" strokeWidth="1.2"/>
        <path d="M26 22v8M22 26h8" stroke="#C9A84C" strokeWidth="1.2" strokeLinecap="round"/>
        <circle cx="26" cy="26" r="4" stroke="#C9A84C" strokeWidth="1"/>
      </svg>
    ),
    name: 'Cardiología Clínica Avanzada',
    desc: 'Domina los fundamentos y la práctica actual. Casos reales, protocolos actualizados y ECG en profundidad.',
    price: '$149 USD',
    badge: 'Más vendido',
    badgeColor: 'var(--gold)',
    hotmart: '#',
  },
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" opacity="0.35">
        <path d="M14 26c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="#C9A84C" strokeWidth="1.2"/>
        <path d="M10 30c0 0 4-2 8 0s8 4 16 0 8-4 8-4" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <circle cx="26" cy="26" r="3" fill="#C9A84C" opacity="0.5"/>
        <path d="M26 16v-4M18 20l-3-3M34 20l3-3" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    name: 'Neurología para Residentes',
    desc: 'Del examen neurológico al diagnóstico diferencial. El curso que necesitabas antes de tu guardia.',
    price: '$129 USD',
    badge: 'Nuevo',
    badgeColor: 'var(--gold)',
    hotmart: '#',
  },
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" opacity="0.35">
        <rect x="17" y="20" width="18" height="14" rx="2" stroke="#C9A84C" strokeWidth="1.2"/>
        <path d="M22 20v-4a4 4 0 018 0v4" stroke="#C9A84C" strokeWidth="1.2" strokeLinecap="round"/>
        <circle cx="26" cy="27" r="2.5" fill="#C9A84C" opacity="0.6"/>
        <path d="M26 29.5v2" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    name: 'Farmacología Aplicada',
    desc: 'Lo que ningún libro explica sobre cómo elegir el fármaco correcto. Enfoque clínico, no memorístico.',
    price: '$99 USD',
    badge: null,
    hotmart: '#',
  },
]

export default function Cursos() {
  return (
    <section
      id="cursos"
      className="relative overflow-hidden"
      style={{ padding: '120px 5vw', background: 'var(--bg-2)' }}
    >
      {/* Subtle cross-hatch bg */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, #C9A84C 0, #C9A84C 1px, transparent 1px, transparent 80px), repeating-linear-gradient(90deg, #C9A84C 0, #C9A84C 1px, transparent 1px, transparent 80px)',
        }}
      />

      <div className="relative z-10">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
            {/* título */}
            <div className="shrink-0">
              <div className="section-label">Cursos disponibles</div>
              <h2
                className="font-display font-black leading-[1.04] tracking-[-0.02em]"
                style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', color: 'var(--ink)' }}
              >
                Formación diseñada<br />
                para{' '}
                <em className="not-italic" style={{ color: 'var(--gold)' }}>
                  resultados reales
                </em>
                .
              </h2>
            </div>

            {/* texto derecho — tres párrafos separados por borde izquierdo dorado */}
            <div
              className="flex flex-col gap-4 max-w-sm"
              style={{ borderLeft: '2px solid rgba(201,168,76,0.25)', paddingLeft: 20 }}
            >
              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Cada curso está pensado como un entrenamiento: primero ordenás el tema,
                después lo razonás y finalmente lo llevás a preguntas reales.
              </p>
              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Dejás de estudiar temas aislados y empezás a ver el sistema completo:
                qué importa, cómo se conecta y cómo te lo pueden tomar.
              </p>
              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Te doy un mapa claro de qué estudiar, cómo estudiarlo, cómo razonarlo
                y cómo responder en el examen.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Grid – separated by 1px gold lines */}
        <div
          className="grid grid-cols-1 md:grid-cols-3"
          style={{ gap: '1px', background: 'var(--line)' }}
        >
          {cursos.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ backgroundColor: 'rgba(22,22,22,1)' }}
              className="relative flex flex-col overflow-hidden"
              style={{ background: 'var(--bg-2)' }}
            >
              {/* Thumb */}
              <div
                className="relative flex items-center justify-center"
                style={{
                  aspectRatio: '4/3',
                  background: 'var(--bg-3)',
                  borderBottom: '1px solid var(--line)',
                }}
              >
                {/* Gold gradient sheen */}
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background: 'linear-gradient(135deg, rgba(201,168,76,0.06) 0%, transparent 60%)',
                  }}
                />
                {c.icon}
                {c.badge && (
                  <div
                    className="absolute top-4 right-4 font-display font-black text-[9px] tracking-[0.12em] uppercase px-2.5 py-1.5"
                    style={{ background: 'var(--gold)', color: '#000' }}
                  >
                    {c.badge}
                  </div>
                )}
              </div>

              {/* Body */}
              <div className="flex flex-col flex-1 p-8">
                <h3
                  className="font-display font-black text-[18px] leading-[1.2] mb-2.5"
                  style={{ color: 'var(--ink)' }}
                >
                  {c.name}
                </h3>
                <p
                  className="font-body font-light text-[13px] leading-[1.75] flex-1"
                  style={{ color: 'var(--ink-2)' }}
                >
                  {c.desc}
                </p>

                {/* Footer */}
                <div
                  className="flex items-center justify-between mt-6 pt-5"
                  style={{ borderTop: '1px solid var(--line-2)' }}
                >
                  <span
                    className="font-display font-black text-[20px]"
                    style={{ color: 'var(--gold)' }}
                  >
                    {c.price}
                  </span>
                  <motion.a
                    href={c.hotmart}
                    className="font-display font-black text-[10px] tracking-[0.1em] uppercase px-5 py-2.5"
                    style={{ background: 'var(--gold)', color: '#000' }}
                    whileHover={{ backgroundColor: '#E2C47A' }}
                    transition={{ duration: 0.15 }}
                  >
                    Comprar
                  </motion.a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}